module.exports = __webpack_public_path__ + "img/armoured-truck.20fe6139.png";